import { processStepsTable as processStepsTableDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export type StepsTableProps = {
    sortState?: string;
}

export const stepsTable = ({
    sortState,
}: StepsTableProps) => {
    return processStepsTableDiagram(sortState);
};
